export default class genericReader {
    constructor() {
        if (!genericReader.instance) {
            genericReader.instance = this;
        }
        return genericReader.instance;
    }

    getGenericValues(value) {
        if (value !== undefined && value !== null) {
            if (typeof value === 'string' || value instanceof String) {
                if(value.toUpperCase() === "TRUE" || value.toUpperCase() === "YES" ) {
                    return 1
                }
            }else if(value === 1) {
                return 1
            }
        }
       
        return 0
    }

    

    getGenericOfflineValues(value) {
        if (value !== undefined && value !== null) {
            if (typeof value === 'string' || value instanceof String) {
                if(value.toUpperCase() === "TRUE" || value.toUpperCase() === "YES") {
                    return "Yes"
                }else{
                    return "No"
                }
            }else if(value === 1) {
                return "Yes"
            }
         }
        
        return "No"
    }
  }